export default __webpack_public_path__ + "dist/media/FileWhite.93592790.svg";